export default "__VITE_ASSET__CkmXUORx__"